$(function () {
  var host = "https://dip.sylvoxtv.com/api/api";
  // 动态渲染select option
  var selectList = [];
  function getSelectList() {
    $.ajax({
      url: host + "/getMater",
      method: "GET",
      contentType: "JSONP",
      data: {},
      success: function (res) {
        if (res.Code == 0) {
          $(".el-select__list").empty();
          if (res.Data.length == 0) {
            $(".el-select__list").append(
              `<li class="el-select__item el-select-disabled" data-value="">No Data</li>`
            );
            return;
          }
          selectList = res.Data;
          selectList.push({'sku':'others','nameEN':'Others'});
          res.Data.forEach(function (opt) {
            $(".el-select__list").append(
              `<li class="el-select__item" data-value="${opt.sku}">${opt.nameEN}</li>`
            );
          });
        } else {
          $(".el-select__list").empty();
          $(".el-select__list").append(
            `<li class="el-select__item" data-value="">No Data</li>`
          );
          showToast(res.Msg);
        }
      },
      error: function (error) {
        $(".el-select__list").append(
          `<li class="el-select__item" data-value="">No Data</li>`
        );
        showToast("Error Failed");
      },
      complete: function (params) {
        $(".el-select__editor").attr("readonly", false);
        $("#selectLoading").removeClass("select-loading-show");
      },
    });
  }
  $("#serialInputLoading").hide();
  getSelectList();
  $("#videoViewClose").on("click", function () {
    $("#videoViewModal").fadeOut(120);
  });
  // 移除错误样式
  $("#email").on("change", function () {
    removeClass("#email", "Email");
  });
  $("#userName").on("change", function () {
    removeClass("#userName", "UserName");
  });
  $("#remark").on("change", function () {
    removeClass("#remark", "Remark");
  });
  function removeClass(className, labelName) {
    $(className).removeClass("error-input");
    $('label[for="' + labelName + '"]')
      .find("span")
      .first()
      .removeClass("error-label");
  }
  var submitBoolen = false;
  let loginnedIn = shopifyCustomer.loggedIn;
  // 提交按钮
  $("#submitBtn").on("click", function () {
    if (submitBoolen) {
      return showToast("Requesting...");
    }
    var hasError = false;
    var requiredFields = [
      { input: "#selectProduct", label: 'label[for="SelectProduct"]' },
      { input: "#remark", label: 'label[for="Remark"] ' },
      { input: "#email", label: 'label[for="Email"] ' },
      { input: "#userName", label: 'label[for="UserName"] ' }
    ];
    requiredFields.forEach(function (f) {
      var $input = $(f.input);
      // var $label = $(f.label).find("span").first();
      var val = $input.val();
      var empty = !val || (f.input === "#mySelect" && val === "");
      if (empty) {
        if(f.input == '#selectProduct'){
          $('.el-select__input').addClass("error-input");
        }else{
          $input.addClass("error-input");
        }
        hasError = true;
      }
    });
    if (hasError) {
      showToast("Incomplete required fields");
      return;
    }
    var terms_Privacy = $("#terms_Privacy").prop("checked");
    var subcribe = $("#subcribe").prop("checked");
    if (!terms_Privacy) {
      $(".terms_Privacy").addClass("shake");
      setTimeout(function () {
        $(".terms_Privacy").removeClass("shake");
      }, 300);
      return;
    }
    if (!subcribe) {
      $(".subcribe").addClass("shake");
      setTimeout(function () {
        $(".subcribe").removeClass("shake");
      }, 400);
      return;
    }
    // 发送请求
    submitForm()
  });
  var uploading = false;
  function submitForm() {
    if(uploading){
      showToast("Uploading...");
      return
    }
    if(!$('#img_url').val() || !$('#video_url').val()){
      showToast("Please upload the video first");
      return
    }
    // 获取表单数据
    var formData = new FormData();
    formData.append("name", $("#userName").val());
    formData.append("email", $("#email").val());
    formData.append("materSku", $("#selectProduct").val());
    formData.append("materName", $("#selectProductName").val());
    formData.append("img",  $('#img_url').val());
    formData.append("vid",  $('#video_url').val());
    formData.append("remark", $("#remark").val());
    $("#submitBtn").prop("disabled", true).html("Submitting...");
    showFullscreenLoading();
    if (submitBoolen) {
      return showToast("Requesting...");
    }
    submitBoolen = true;
    // 发送请求
    $.ajax({
      url: host + "/addShopifyVedios",
      method: "POST",
      processData: false,
      contentType: false,
      data: formData,
      success: function (res) {
        if (res.Code == 0) {
          $('.video-form').hide();
          $('html, body').animate({scrollTop: 0}, 800);
          $('.form-success-contair').show();
        } else {
          showToast(res.Msg);
        }
      },
      error: function (xhr) {
        showToast("Submit failed");
      },
      complete: function () {
        $("#submitBtn").prop("disabled", false).html("Submit");
        hideFullscreenLoading();
        submitBoolen = false;
      },
    });
  }
  $("#modalClose").on("click", function () {
    $("#myModal").fadeOut(150);
    setTimeout(function () {
      $("#createAccount").html("");
      $("#ModalText").html("");
    }, 150);
  });
  // JSONP回调函数
  function handleUploadResponse(data) {
    if (data.status === "success") {
      return data.data;
    }
  }
  // 文本域字数统计
  $("#remark").on("input", function () {
    var len = $(this).val().length;
    $("#descCounter").text(len + "/2000");
  });
  // Toast 提示框
  function showToast(msg, duration) {
    duration = duration || 2000;
    var $toast = $("#globalToast");
    $toast.text(msg).addClass("show");
    clearTimeout($toast.data("timer"));
    var timer = setTimeout(function () {
      $toast.removeClass("show");
    }, duration);
    $toast.data("timer", timer);
  }
  function showFullscreenLoading() {
    $(".loader-content").find('#loader-text').css('display','none');
    let contentText = '<p class="loader-text" style="margin:0;">Submitting, thank you for sharing...</p>'
    $(".loader-content").append(contentText);
    PageLoader.show();
  }
  function hideFullscreenLoading() {
    $(".loader-content").find('#loader-text').css('display','block');
    $(".loader-content .loader-text").remove();
    PageLoader.hide();
  }
  const $select = $(".el-select");
  const $input = $select.find(".el-select__input");
  const $editor = $select.find(".el-select__editor");
  const $dropdown = $select.find(".el-select__dropdown");
  const $arrow = $select.find(".el-select__arrow");
  const $list = $select.find(".el-select__list");

  // 展开/收起下拉框
  $input.on("click", function (e) {
    e.stopPropagation();
    if (e.target === $editor[0]) return;
    toggleDropdown();
  });

  // 编辑器获取焦点时自动展开
  $editor.on("focus", function () {
    if (!$dropdown.hasClass("el-select__dropdown--visible")) {
      toggleDropdown(true);
    }
  });

  // 输入内容时过滤选项
  $editor.on("input", function () {
    const keyword = $(this).val();
    $list.empty();
    const filtered = selectList.filter((item) =>
      item.nameEN.includes(keyword)
    );
    if (filtered.length === 0) {
      $list.append('<li style="color:#999;text-align:center;">No Matched</li>');
      return;
    }
    filtered.forEach((item) => {
      $list.append(
        `<li class="el-select__item" data-value="${item.sku}">${item.nameEN}</li>`
      );
    });
  });

  // 选择选项
  $list.on("click", ".el-select__item", function () {
    const $item = $(this);
    const value = $item.data("value");
    if (!value) return;
    $("#selectProduct").val(value);
    $("#selectProductName").val($item.text());
    removeClass(".el-select__input", "SelectProduct");
    const text = $item.text();
    $(".el-select__editor").val(text);
    $list.find(".el-select__item").removeClass("el-select__item--selected");
    $item.addClass("el-select__item--selected");
    toggleDropdown(false);
    // 触发change事件
    $select.trigger("change", { value, text });
  });

  // 点击页面其他区域收起下拉框
  $('body').on("click", function (e) {
    if (!$(".el-select__editor").val() && $("#selectProduct").val() !== '') {
      const value = $("#selectProduct").val();
      const text = selectList.filter((item) => item.sku == value);
      $(".el-select__editor").val(text[0].nameEN);
      $("#selectProductName").val(text[0].nameEN);
    }

    if (!$dropdown.hasClass("el-select__dropdown--visible")) return;
    toggleDropdown(false, "body");
  });

  function toggleDropdown(show, type) {
    const isVisible =
      typeof show === "boolean"
        ? !show
        : $dropdown.hasClass("el-select__dropdown--visible");
    $dropdown.toggleClass("el-select__dropdown--visible");
    $input.toggleClass("el-select__input--focus");
    $arrow.css("transform", isVisible ? "rotate(0deg)" : "rotate(180deg)");
  }
  let fileInfo = {}
  let currentXHR = null;
  // 文件拖拽
  const $dropzone = $(".upload-video-choose-content");
  // 拖拽事件处理
  $dropzone
    .on('dragover', function(e) {
      e.preventDefault();
      e.stopPropagation();
    })
    .on('dragleave', function(e) {
      e.stopPropagation();
    })
    .on('drop', function(e) {
      e.preventDefault();
      e.stopPropagation();
      const files = e.originalEvent.dataTransfer.files;
      if(files.length > 0) {
        fileInfo = files[0];
        validateAndUpload(files[0]);
      }
    });
    // 按钮上传
    $('#uploadBtn').on('click',function(e){
      e.stopPropagation();
      $("#uploadFileInput").click();
    })
    $("#uploadFileInput").on("change", function (e) {
      var files = e.target.files;
      if(files.length > 0) {
        fileInfo = files[0];
        validateAndUpload(files[0]);
      }
    });
    // 文件验证和上传
  function validateAndUpload(file) {
    const videoURL = URL.createObjectURL(file);
    $('#viewVideo').attr('src', videoURL);
    $('#previewVideo').attr('src', videoURL);
    // 生成缩略图
    $('#viewVideo').on('loadedmetadata', function() {
      $('#viewVideo')[0].currentTime = 1;
    });
    
    $('#viewVideo').on('seeked', function() {
      const ctx = $('#thumbnailCanvas')[0].getContext('2d');
      $('#thumbnailCanvas')[0].width = 854;
      $('#thumbnailCanvas')[0].height = 480; 
      ctx.drawImage(this, 0, 0, $('#thumbnailCanvas')[0].width, $('#thumbnailCanvas')[0].height);
      $('#thumbnailPreview').attr('src', $('#thumbnailCanvas')[0].toDataURL());
      $('#previewVideo').attr('poster', $('#thumbnailCanvas')[0].toDataURL());
    });
    const maxSize = 500 * 1024 * 1024; // 500MB
    const $error = $dropzone.find('.upload-requirement');
    // 验证文件类型
    if(!file.type.match('video/mp4')) {
      $error.text('Upload failed. Please make sure you upload MP4 file.');
      $error.css('color','#e74330')
      return;
    }
    // 验证文件大小
    if(file.size > maxSize) {
      $error.text('Upload failed. Please make sure the uploaded memory is less than 500MB.');
      $error.css('color','#e74330')
      return;
    }
    $error.text('Requirement: Video should be shoot in Clear Mode. Only supports MP4 file. Max size: 500 MB.');
    $error.css('color','rgb(119, 119, 119)');
    $('.upload-video-choose').hide();
    $('.upload-video-info').removeClass('video-hide');
    $('.basic-info-form-contair').removeClass('video-hide');
    uploadToShopify(file);
  }
  // 上传到服务器
  function uploadToShopify(file) {
    const formData = new FormData();
    $("#submitBtn").prop("disabled", true)
    formData.append('vid', file);
    $('.video-name').text(file.name);
     $('.progress-text-one').text('Uploading... Please keep this page open until it’s done.');
    currentXHR = $.ajax({
      url: host+'/uploadVidAndImg',
      type: 'POST',
      data: formData,
      processData: false,
      contentType: false,
      xhr: function() {
        const xhr = new XMLHttpRequest();
        $('.progress-close').removeClass('video-hide');
        xhr.upload.addEventListener('progress', function(e) {
          if(e.lengthComputable) {
            const percent = Math.floor((e.loaded / e.total) * 100);
            $('.progress-ratio').text(percent+ '%')
            $('.progress-width').css('width', percent + '%');
            if(percent == 100){
              $('.progress-close').addClass('video-hide');
            }
          }
        }, false);
        return xhr;
      },
      success: function(response) {
        $('.progress-text-one').text('Video uploaded successfully.');
        $('.delete-btn').removeClass('video-hide');
        if(response.Code == 0){
          if(response.Data && response.Data.img){
            $('#img_url').val(response.Data.img.path)
          }
          if(response.Data && response.Data.vid){
            $('#video_url').val(response.Data.vid.path)
          }
          $("#submitBtn").prop("disabled", false)
        }else{
          $('.progress-text-one').text(response.Msg);
          $('.delete-btn').removeClass('video-hide')
        }
      },
      error: function(xhr, status, error) {
        if (status !== 'abort') {
          $('.progress-text-one').text('Video uploaded faild.');
          $('.delete-btn').removeClass('video-hide')
        }
      }
    });
  }
  // 取消文件上传
  function cancelUpload(){
    if (currentXHR) {
      currentXHR.abort();
      resetUploadUI();
    }
  }
  // 重置参数
  function resetUploadUI(){
    $dropzone.find('.upload-requirement').text('Requirement: Video should be shoot in Clear Mode. Only supports MP4 file. Max size: 500 MB.');
    $dropzone.find('.upload-requirement').css('color','rgb(119, 119, 119)');
    $('.upload-video-info').addClass('video-hide');
    $('.basic-info-form-contair').addClass('video-hide');
    $('.upload-video-choose').show();
    $('.progress-ratio').text('0%')
    $('.progress-width').css('width', '0%');
    $('.delete-btn').addClass('video-hide');
    $('#uploadFileInput').val('');
    $('#viewVideo').attr('src', '');
    $('#previewVideo').attr('src', '');
    $('#thumbnailPreview').attr('src', '');
    $('#previewVideo').attr('poster','');
    currentXHR = null;
    fileInfo = {}
    $("#submitBtn").prop("disabled", 'ture');
    uploading = false
  }
  let popType = null
  // 删除上传视频
  $('#deleteBtn').on('click',function(){
    confirmPop('del','Are you sure you want to delete the video?');
    popType = 'del'
  })
  // 取消上传视频
  $('#cancelBtn').on('click',function(){
    confirmPop('cancel','Are you sure you want to cancel the upload?');
    popType = 'cancel'
  })
  function confirmPop(type,text){
    $('#ModalText').text(text);
    if(type == 'del'){
      $('#modalCofirm').text('Delete');
      $('#modalCancel').text('Cancel');
    }else{
      $('#modalCofirm').text('Cancel Upload');
      $('#modalCancel').text('Confirm Upload');
    }
    $("#myModal").fadeIn(150);
  }
  $('#modalCancel').on('click',function(){
    $("#myModal").fadeOut(150);
    popType = null
  })
  $('#modalCofirm').on('click',function(){
     $("#myModal").fadeOut(150);
    if(popType == 'cancel'){
      cancelUpload()
    }else{
      resetUploadUI()
    }
    popType = null
  })
  $('.play-icon').on('click',function(){
    $('#videoViewModal').fadeIn(150);
  })
});
